export const GET_GOVERNANCE_LIST = "GET_GOVERNANCE_LIST";
export const GOVERNANCE_LIST = "GOVERNANCE_LIST";

export const SEARCH_GOVERNANCE_BY_ID = "SEARCH_GOVERNANCE_BY_ID";
export const GOVERNANCE_BY_ID = "GOVERNANCE_BY_ID";

export const SEARCH_GOVERNANCE_BY_FIELD = "SEARCH_GOVERNANCE_BY_FIELD";
export const GOVERNANCE_BY_FIELD_LIST = "GOVERNANCE_BY_FIELD_LIST";

export const ADD_GOVERNANCE = "ADD_GOVERNANCE";
export const ADD_GOVERNANCE_RESPONSE = "ADD_GOVERNANCE_RESPONSE";

export const UPDATE_GOVERNANCE = "UPDATE_GOVERNANCE";
export const UPDATE_GOVERNANCE_RESPONSE = "UPDATE_GOVERNANCE_RESPONSE";

export const DELETE_GOVERNANCE = "DELETE_GOVERNANCE";
export const DELETE_GOVERNANCE_RESPONSE = "DELETE_GOVERNANCE_RESPONSE";

export const VALIDATE_START_DATE = "VALIDATE_START_DATE";
export const VALIDATE_START_DATE_RESP = "VALIDATE_START_DATE_RESP";
